import React from 'react'
import { useHistory } from 'react-router-dom'
import { WemoloTextLink } from '../Wemolo'

type LinkTarget = '_blank' | '_self'

export const Link = ({
    link,
    text,
    target = '_blank'
}: {
    link?: string
    text: string | React.ReactNode
    target?: LinkTarget
}) => {
    const history = useHistory()
    const handleClick = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
        if (!link) return
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) {
            return
        }
        event.preventDefault()
        if (target === '_blank') {
            window.open(link, '_blank', 'noopener,noreferrer')
            return
        }
        history.push(link)
    }
    return (
        <WemoloTextLink size="small" href={link} onClick={handleClick}>
            {text}
        </WemoloTextLink>
    )
}
